import Column from "theme/layouts/Column";
import PropTypes from "prop-types";
import React from "react";
import TextStyles from "theme/components/text/TextStyles";
import Wysiwyg from "theme/libs/wordpress/components/Wysiwyg";
import { above } from "core-web/utils/mediaqueries";
import styled from "theme/libs/styled";

const StyledColumn = styled(Column)`
    :not(:last-of-type) {
        margin-bottom: 32px;

        ${above.tabletLg} {
            margin-bottom: 48px;
        }
    }
`;

const Paragraph = ({ data, isCustomerService }) => (
    <StyledColumn gap="24px">
        <Wysiwyg
            data={data}
            validTags={["url", "i", "b", "u", "br", "ul", "li", "ol", "h1", "h2", "h3", "h4", "h5", "h6"]}
            textComponent={(props) => (
                <TextStyles
                    as="p"
                    textStyles={isCustomerService ? "Myriad Pro/18-140" : "Myriad Pro/16-140"}
                    {...props}
                />
            )}
        />
    </StyledColumn>
);

Paragraph.propTypes = {
    data: PropTypes.array,
    isCustomerService: PropTypes.bool,
};

Paragraph.defaultProps = {
    data: [],
    isCustomerService: false,
};

export default Paragraph;
